import { mapGetters } from 'vuex';
import { isEmptyVal } from '@/utils';
import _ from 'lodash';
import { createLoadingPlaceholder } from '@/views/config/partner-refer/helper/utils';

const calculateDistributePlanQuantity = (selectedPlanMap = {}, distributionDependPlanList = []) => {
  return _.chain(selectedPlanMap)
    .keys()
    .reduce((total, planCode) => {
      if (_.includes(distributionDependPlanList, planCode)) {
        total += selectedPlanMap[planCode];
      }

      return total;
    }, 0)
    .value();
};

export default {
  computed: {
    ...mapGetters(['partnerRefer', 'getSelectedPlansWithQuantityMap']),
    currentDistributePlanQuantity() {
      const selectedPlanMap = this.getSelectedPlansWithQuantityMap;
      const distributionDependPlanList = this.partnerRefer.features?.distributionDependPlanList;

      if (!isEmptyVal(distributionDependPlanList)) {
        return calculateDistributePlanQuantity(selectedPlanMap, distributionDependPlanList);
      }

      const flattenEligiblePlanList = this.partnerRefer.features?.flattenEligiblePlanList;

      if (!isEmptyVal(flattenEligiblePlanList)) {
        return calculateDistributePlanQuantity(selectedPlanMap, flattenEligiblePlanList);
      }

      return 0;
    },
  },
  methods: {
    replaceContentWithDynamicQuantity(content = '') {
      const containDynamicDistributeQuantity = this.partnerRefer.features?.containDynamicDistributeQuantity;

      if (containDynamicDistributeQuantity) {
        const currentDistributePlanQuantity = this.currentDistributePlanQuantity;
        const replaceTxt = currentDistributePlanQuantity ? currentDistributePlanQuantity : createLoadingPlaceholder();
        return _.replace(content, `\${distributeQuantity}`, replaceTxt);
      }

      return content;
    },
  }
};
